let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bNytz")).then(() => parcelRequire('fBRAI'));